import { Box } from '@mui/material'
import { LockClosed16Regular } from '@/components/Icon'
import detail from '@/components/ScheduleDetails/scheduleDetails.module.scss'
import styles from './customModelDialog.module.scss'

export default function CustomModelFooter({ canRemove, onRemove, onClose }) {
  return (
    <Box className={styles.footer}>
      <span className={styles.note}>
        <LockClosed16Regular aria-hidden />
        Your key is masked after saving and never shown again.
      </span>
      {canRemove ? (
        <button type="button" className={styles.removeButton} onClick={onRemove}>
          Remove
        </button>
      ) : null}
      <button type="button" className={detail.cancelButton} onClick={onClose}>
        Cancel
      </button>
      <button type="submit" className={detail.saveButton}>
        Save and use
      </button>
    </Box>
  )
}
